import { SaveConversationRequest, SaveConversationResponse } from '../types/models';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

class ConversationService {
  private async uploadToBlobStorage(
    audioBlob: Blob,
    inwoner: string,
    accessToken: string
  ): Promise<{ blobName: string; blobUrl: string }> {
    console.log('🔑 Getting SAS token for:', inwoner);
    
    const tokenResponse = await fetch(
      `${API_BASE_URL}/upload-token?inwoner=${encodeURIComponent(inwoner)}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      }
    );

    if (!tokenResponse.ok) {
      throw new Error('Failed to get upload token');
    }

    const { sasUrl, blobName } = await tokenResponse.json();
    
    console.log('📤 Uploading to Blob Storage...');
    console.log('  Blob name:', blobName);
    console.log('  Blob size:', audioBlob.size, 'bytes');
    
    const uploadResponse = await fetch(sasUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': audioBlob.type,
      },
      body: audioBlob,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Blob upload failed: ${uploadResponse.status}`);
    }

    console.log('✅ Direct upload successful!');
    
    const blobUrl = sasUrl.split('?')[0];
    
    return { blobName, blobUrl };
  }

  async saveConversation(
    request: SaveConversationRequest,
    accessToken: string
  ): Promise<SaveConversationResponse> {
    console.log('🚀 saveConversation START');

    try {
      // Step 1: Upload blob
      const { blobName, blobUrl } = await this.uploadToBlobStorage(
        request.audioBlob,
        request.inwoner,
        accessToken
      );

      console.log('📝 Creating SharePoint entry...');

      // Step 2: Save metadata (including dossierId)
      const response = await fetch(`${API_BASE_URL}/conversations`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inwoner: request.inwoner,
          datumGesprek: request.datumGesprek,
          typeGesprek: request.typeGesprek,
          duration: request.duration,
          blobName,
          blobUrl,
          dossierId: request.dossierId, // ← NEW
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ API Error:', errorText);
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ SUCCESS:', data);

      return {
        success: true,
        conversationId: data.conversationId,
        blobPath: blobName,
        blobUrl: blobUrl,
        message: 'Gesprek succesvol opgeslagen',
      };
    } catch (error) {
      console.error('💥 ERROR in saveConversation:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Onbekende fout',
      };
    }
  }
}

export const conversationService = new ConversationService();